import { ANDROID_OS_NAME, IOS_OS_NAME } from '../../lib/device/constants';

/**
 * The default os app to use when failed to match one.
 * @type {String}
 */
export const DEFAULT_OS_APP = ANDROID_OS_NAME;

/**
 * The OS name to app banner data mapping.
 * @type {Object<AppData>}
 */
export const OS_APP_DATA = {
    [ANDROID_OS_NAME]: {
        dismissCookie: 'android_smart_banner_hidden',
        nativeAppUrl: 'https://app.appsflyer.com/com.fiverr.fiverr?pid=Organic&c=MobileAndroidSmartBanner',
        reviews: 68144,
        ratings: 4.5
    },
    [IOS_OS_NAME]: {
        dismissCookie: 'ios_smart_banner_hidden',
        nativeAppUrl: 'https://app.appsflyer.com/id346080608?pid=Organic&c=MobileIosSmartBanner',
        reviews: 3650,
        ratings: 4.9
    }
};

/**
 * The expiry time of app banner related cookies (2 weeks).
 * @type {Number}
 */
export const COOKIE_EXPIRES = 1000 * 3600 * 24 * 7 * 2; // 2 weeks
